'use client'

import { useLanguage } from '@/lib/i18n/LanguageContext'
import { Button } from '@/components/ui/button'

interface GoogleNudgeProps {
  email: string
  onGoogle: () => void
  disabled?: boolean
}

/**
 * For a Google-hosted mailbox that keeps failing with codes: Google sign-in
 * needs no email at all. Shown only when /api/auth/otp reported googleMail –
 * for any other mailbox Google sign-in would create a second account.
 */
export default function GoogleNudge({ email, onGoogle, disabled }: GoogleNudgeProps) {
  const { t } = useLanguage()
  return (
    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg space-y-3 text-center">
      <p className="text-sm font-semibold text-gray-900">{t('authModal.googleNudgeTitle')}</p>
      <p className="text-sm text-gray-700">{t('authModal.googleNudgeBody')}</p>
      <Button type="button" variant="outline" className="w-full bg-white" onClick={onGoogle} disabled={disabled}>
        {t('authModal.continueWithGoogle')}
      </Button>
      {/* Google signs in with the account picked there; any other account
          would become a second CONFY profile. */}
      <p className="text-xs text-gray-500 [overflow-wrap:anywhere]">{t('authModal.googleNudgeAccount').replace('{email}', email)}</p>
    </div>
  )
}
